var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "kvm-dop",
      class: "kvm-dop--" + _vm.state
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-center"
        },
        [
          _vm.state === "running"
            ? _c("v-progress-circular", {
                staticClass: "mr-2",
                attrs: {
                  indeterminate: "",
                  size: "16",
                  width: "2",
                  color: "primary",
                  "aria-hidden": "true"
                }
              })
            : _c(
                "v-icon",
                {
                  staticClass: "mr-2",
                  attrs: {
                    small: "",
                    color: _vm.state === "succeeded" ? "success" : "error",
                    "aria-hidden": "true"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.state === "succeeded"
                          ? "mdi-check-circle"
                          : "mdi-alert-circle"
                      ) +
                      " "
                  )
                ]
              ),
          _c(
            "span",
            {
              staticClass: "body-2 font-weight-medium mr-2"
            },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _c(
            "span",
            {
              staticClass: "kvm-dop__state text-caption mr-auto",
              attrs: {
                role: "status",
                "aria-live": "polite"
              }
            },
            [_vm._v(_vm._s(_vm.stateText))]
          ),
          _c(
            "gg-btn",
            {
              staticClass: "kvm-dop__btn",
              attrs: {
                text: "",
                small: "",
                "aria-expanded": _vm.showOutput ? "true" : "false"
              },
              on: {
                click: function click($event) {
                  _vm.showOutput = !_vm.showOutput
                }
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.showOutput ? "Hide output" : "Show output") +
                  " "
              )
            ]
          ),
          _vm.state !== "running"
            ? _c(
                "gg-btn",
                {
                  attrs: {
                    icon: "",
                    small: "",
                    "aria-label": "Dismiss"
                  },
                  on: {
                    click: function click($event) {
                      return _vm.$emit("dismiss")
                    }
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        small: ""
                      }
                    },
                    [_vm._v("mdi-close")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.showOutput
        ? _c(
            "pre",
            {
              ref: "out",
              staticClass: "kvm-dop__out"
            },
            [_vm._v(_vm._s(_vm.displayOutput || "Waiting for output…"))]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }